// extracted by mini-css-extract-plugin
module.exports = {"GoodbyePageWrapper":"GoodbyePage_GoodbyePageWrapper__3NdLI","MessageBox":"GoodbyePage_MessageBox__3YIKi"};